/**
 @ngdoc directive
 @name defaultSearchTerm

 @description
 Loads a search term template based on search term type and populates with data

 @usage
 <default-search-term search-term="searchTerm"></default-search-term>

 @param {search-term}  json data                       - Individual search term data

 */

(function() {
    'use strict';
    var defaultSearchTerm = function ($templateCache, $http) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                formModel: "=",
                searchTerm: "=",
                searchTerms: "=",
                lookupUrl: "=",
                editstate: "=",
                index: "@"
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/defaultSearchTerm.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                var DROPDOWN_MULTI_SELECTION_TYPES = ['MULTISELECT_DROPDOWN','MAGIC_LOOKUP'];
                var DROPDOWN_SINGLE_SELECTION_TYPES = ['VIEWED_BY','DROPDOWN'];
                var DROPDOWN_TYPES = DROPDOWN_SINGLE_SELECTION_TYPES.concat(DROPDOWN_MULTI_SELECTION_TYPES);

                /**
                 * Initialises the model for defaultSearchTerms[_this.searchTerm.id] and collects the dropdown data if required
                 */
                this.$onInit = function(){
                    //set type into model for ease
                    _this.searchTerm.typeName = $scope.getSearchTermTypeId( _this.searchTerm.type );
                    //console.log('initSearchTerm',searchTerm.typeName,searchTerm,defaultSearchTerms);
                    //collect data
                    getDropdownList();
                    //set the default search term
                    setModel();
                };

                /**
                 *  Set up the model structure
                 *
                 *  defaultSearchTerms: {
                 *      {searchTerm.id} : { ? },                                  //MULTISELECT_DROPDOWN|MAGIC_LOOKUP|TAG_SEARCH|CHECKBOX
                 *      {searchTerm.id} : { type: string, tags: { ? } },          //BUSINESS_NAME
                 *      {searchTerm.id} : { value: String },                      //TEXTBOX|TEXTBOX_S|TEXTBOX_T|VIEWED_BY|DROPDOWN
                 *      {searchTerm.id} : { value: Boolean },                                               //CHECKBOX
                 *      {searchTerm.id} : { value: String, type: String, tags: String },                    //BUSINESS_NAME
                 *      {searchTerm.id} : { postCode: String, distance: String, distanceType: String },     //POSTCODE_RADIUS
                 *      {searchTerm.id} : { postCode: String, time: String, timeType: String, transportType: String },     //TRAVEL_tIME
                 *      {searchTerm.id} : { fromValue: Date, toValue: Date },                               //DATE_RANGE
                 *      {searchTerm.id} : { fromValue: ?, toValue: ? },                                     //NUMERIC_RANGE
                 *      {searchTerm.id} : { fromValue: ?, toValue: ?, timeUnit.id: int }                    //NUMERIC_RANGE_INT_DDL
                 *  }
                 */
                var setModel = function(){
                    if(_this.formModel.defaultSearchTerms===undefined){
                        _this.formModel.defaultSearchTerms = {};
                    }
                    if (['VIEWED_BY', 'DROPDOWN', 'NUMERIC', 'TEXTBOX', 'TEXTBOX_S', 'TEXTBOX_T', 'PRINCIPAL_TEXT'].includes(_this.searchTerm.typeName)) {
                        var searchTermValue = _this.searchTerm.value ? _this.searchTerm.value[_this.index] : null;
                        _this.formModel.defaultSearchTerms[_this.searchTerm.id] = {};
                        _this.formModel.defaultSearchTerms[_this.searchTerm.id][_this.index] = {
                            value: searchTermValue
                        }
                    } else if (['MULTISELECT_DROPDOWN', 'MAGIC_LOOKUP', 'TAG_SEARCH', 'CHECKBOX', 'BUSINESS_NAME'].includes(_this.searchTerm.typeName)) {
                        //TODO: It would be nice to unify these to {obj}.value
                        _this.formModel.defaultSearchTerms[_this.searchTerm.id] = _this.searchTerm.value ? _this.searchTerm.value : null;
                    }
                };

                /**
                 * Collects dropdown data for usage by the multi selections and single selections
                 * @param searchTerm
                 */
                var getDropdownList = function(){
                    if( DROPDOWN_TYPES.includes(_this.searchTerm.typeName) ) {
                        //console.log('getDropdownList',searchTerm.typeName);
                        var url = WEBAPP_PATH + '/advancedSearch/dropDownLookup?searchFieldId=' + _this.searchTerm.searchFieldId;
                        if (DROPDOWN_MULTI_SELECTION_TYPES.includes(_this.searchTerm.typeName)) {
                            url += '&mapFormat=true'
                        }
                        $http({
                            method: 'GET',
                            url: url
                        }).then(function successCallback(response) {
                            _this.dropdownList = response.data;
                            //console.log(_this.searchTerm.label, _this.searchTerm.typeName,'Object.keys(_this.dropdownList).length',Object.keys(_this.dropdownList).length);
                        });
                    }
                };

                _this.timeUnits = [
                    {id:324, name:"Days"},
                    {id:325, name:"Weeks"},
                    {id:733, name:"Months"}
                ];

                // search condition constants
                _this.IS_BLANK = {value: 602, label: 'is blank'};
                _this.IS_BETWEEN = {value: 4691, label: 'is between'};
                _this.IS_NOT_BETWEEN = {value: 4692, label: 'is not between'};
                _this.IS_TODAY = {value: 4693, label: 'is today'};
                _this.IS_NOT_BLANK = {value: 5005, label: 'is not blank'};
                _this.IS_WITHIN_LAST = { value: 4694, label: 'is within last' };
                _this.IS_WITHIN_NEXT = {value: 4695, label: 'is within next'};
                _this.IS_NOT_WITHIN_LAST = {value: 5768, label: 'is not within last'};

                _this.IS_MINE = {value: 5919, label: 'is mine'};
                _this.IS_ANY = {value: 5920, label: 'is any'};
                _this.IS_MY_OU = {value: 5366, label: 'is my OU'};

                // time period constants
                _this.MINUTES = {value: 4811, label: 'Minutes'};
                _this.HOURS = {value: 4812, label: 'Hours'};
                _this.DAYS = {value: 4813, label: 'Days'};
                _this.WEEKS = {value: 4814, label: 'Weeks'};
                _this.MONTHS = {value: 4815, label: 'Months'};
                _this.PERIODS = {value: 4816, label: 'Periods'}; // not including in X3-15618


                // transport options
                _this.DRIVING = {value: 6546, label: 'Driving'};
                _this.WALKING = {value: 6547, label: 'Walking'};
                _this.CYCLING = {value: 6548, label: 'Cycling'};
                _this.PUBLIC_TRANSPORT = {value: 6549, label: 'Public Transport'};

                // is current constants
                _this.EXCLUDE_CURRENT = {value: 4817, label: 'Exclude Current'};
                _this.INCLUDE_CURRENT = {value: 4818, label: 'Include Current'};

                // groupings
                _this.DATE_BETWEEN = [_this.IS_BETWEEN.value, _this.IS_NOT_BETWEEN.value];
                _this.WITHIN = [_this.IS_WITHIN_LAST.value, _this.IS_WITHIN_NEXT.value, _this.IS_NOT_WITHIN_LAST.value];
                _this.DAYS_WEEKS_MONTHS = [_this.DAYS.value, _this.WEEKS.value, _this.MONTHS.value];

                _this.searchConditionOptions = [
                    _this.IS_BLANK,
                    _this.IS_BETWEEN,
                    _this.IS_NOT_BETWEEN,
                    _this.IS_TODAY,
                    _this.IS_NOT_BLANK,
                    _this.IS_WITHIN_LAST,
                    _this.IS_WITHIN_NEXT,
                    _this.IS_NOT_WITHIN_LAST
                ];

                _this.searchConditionRemitOptions = [
                    _this.IS_ANY,
                    _this.IS_MINE,
                    _this.IS_MY_OU
                ];

                _this.timePeriodOptions = [
                    _this.MINUTES,
                    _this.HOURS,
                    _this.DAYS,
                    _this.WEEKS,
                    _this.MONTHS
                ];

                _this.transportOptions = [
                    _this.DRIVING,
                    _this.WALKING,
                    _this.CYCLING,
                    _this.PUBLIC_TRANSPORT
                ];

                _this.isCurrentOptions = [
                    _this.EXCLUDE_CURRENT,
                    _this.INCLUDE_CURRENT
                ];

                // Mapping out search term types against their ID for readability
                var SEARCH_TERM_TYPE = {
                    5215: "BUSINESS_NAME",
                    592: "CHECKBOX",
                    590: "DATE",
                    591: "DATE_RANGE",
                    4700: "DOUBLE",
                    5113: "DROP_DOWN_WITH_RANGE",
                    593: "DROPDOWN",
                    4702: "LONG",
                    755: "MAGIC_LOOKUP",
                    594: "MULTISELECT_DROPDOWN",
                    588: "NUMERIC",
                    4510: "NUMERIC_INT_RANGE",
                    589: "NUMERIC_RANGE",
                    4519: "NUMERIC_RANGE_INT_DDL",
                    756: "POSTCODE_RADIUS",
                    5537: "PRINCIPAL_TEXT",
                    707: "RELATIVE_DATE_RANGE",
                    5000: "SHIFT",
                    4699: "STRING",
                    5389: "TAG_SEARCH",
                    587: "TEXTBOX",
                    4516: "TEXTBOX_S",
                    4515: "TEXTBOX_T",
                    647: "TIME_RANGE",
                    757: "TREE_DROPDOWN",
                    5196: "VIEWED_BY",
                    5921: "REMIT_SEARCH",
                    5929: "ASSIGNEE_SEARCH",
                    6543: "TRAVEL_TIME"
                };

                // Function that passes the name into ng-switch for code readability
                $scope.getSearchTermTypeId = function(searchTerm){
                    return SEARCH_TERM_TYPE[searchTerm];
                };
            }]
        };
    };

    defaultSearchTerm.$inject = ['$templateCache', '$http'];
    angular.module('app').directive('defaultSearchTerm', defaultSearchTerm);

}());
